/**
 * The kinds of job a task can be, for the screens that offer or mark them.
 *
 * ⚠️ MUST MATCH `be/config/tasks.js` (`MANUAL_TASK_TYPES`) — the server refuses anything else with
 * `TASK_006`. Same mirror arrangement as roles (`be/config/roles.js` ↔ `config/roleConfig.js`).
 *
 * CODES AND MARKS ONLY. The WORDS live in `locales/{ar,en}.js` under `tasks.type.*`, because the
 * task screens are bilingual (I18N_STRATEGY) — this file is a mapping layer, like
 * `config/suppliesLabels.js`, never a place to put copy.
 *
 * One job, one type: نظافة cleans the unit · صيانة fixes, buys or replaces · مستلزمات ضيافة refills
 * the guest consumables. `housekeeping` is not offered — it meant "whatever the cleaning team does",
 * which is the other three — but tasks created before that decision keep it, so it still has a mark.
 */

/** What a person may create, in the order a form offers them. */
export const MANUAL_TASK_TYPES = ['cleaning', 'maintenance', 'restock'];

/** What a list can be filtered by. Legacy «تدبير منزلي» tasks are still reachable under «الكل». */
export const TASK_TYPE_FILTERS = MANUAL_TASK_TYPES;

/**
 * How a type is marked on a card: the icon and the colour of its badge.
 * Cleaning is the majority of every list and carries no badge — a mark everything has marks nothing.
 */
export const TASK_TYPE_BADGES = {
  // Navy, not the brand purple: the guest-request chip beside it is purple, and two identical
  // chips on one card say "same kind of thing" when they do not.
  maintenance: { icon: '🔧', color: '#090040' },
  restock: { icon: '🧴', color: '#ff9f53' },
  housekeeping: { icon: '🧺', color: '#6c757d' }   // legacy only — no longer created
};

/** The badge for a task type, or null when the type is not marked (a clean, or an unknown type). */
export const taskTypeBadge = (type) => TASK_TYPE_BADGES[type] || null;
